var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('column-chart',{staticClass:"pa-4",attrs:{"colors":['#ff6214'],"data":[
    ['Pending', _vm.pending],
    ['Submitted', _vm.submitted],
    ['Confirmed', _vm.confirmed],
    ['Completed', _vm.completed] ]}})}
var staticRenderFns = []

export { render, staticRenderFns }